import reducer from './reducers';

import * as dashboardActions from './actions';
import * as dashboardTypes from './types';

export { dashboardActions, dashboardTypes };

export default reducer;
